<template>
  <div class="contact-page-container">
    <div class="banner-container">
      <div class="title contact-page-enter">
        <span>联系我们</span>
        <span>Contact</span>
        <span>告诉我们您的需求，改变即刻开始</span>
      </div>
    </div>
    <div class="contact-content">
      <div class="contact-content-title contact-page-enter">
        <span>定制您的服务</span>
      </div>
      <div class="content-container">
        <div class="left contact-page-left-enter">
          <div class="title"><span>联系我们</span></div>
          <div class="content-card">
            <div class="logo">
              <img src="@/assets/image/icon-phone.png" alt=""/>
            </div>
            <div class="content">
              <span>联系电话</span>
              <span>+86 158-8887-9301</span>
            </div>
          </div>
          <div class="content-card">
            <div class="logo">
              <img src="@/assets/image/icon-location.png" alt=""/>
            </div>
            <div class="content">
              <span>公司地址</span>
              <span>杭州市西湖区蓝海时代国际大厦1号楼A12A13</span>
            </div>
          </div>
          <div class="content-card">
            <div class="logo">
              <img src="@/assets/image/icon-wx.png" alt=""/>
            </div>
            <div class="content">
              <span>微信客服</span>
              <span>扫码获得业务帮助</span>
            </div>
          </div>
          <div class="qr-code-container"></div>
        </div>
        <div class="right contact-page-right-enter">
          <div class="demand-container">
            <div class="title"><span>服务需求</span></div>
            <div class="btns-container">
              <div
                class="btn"
                :class="{ active: activeDemandIndex == item.id }"
                v-for="item in demandTypeData"
                :key="item.id"
                @click="activeDemandIndexChange(item.id)"
              >
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
          <div class="contact-form-container">
            <div class="title"><span>联系方式</span></div>
            <div class="input-container">
              <input
                type="text"
                placeholder="填写您的名字"
                v-model="userMsgdata.username"
              />
              <input
                type="text"
                placeholder="填写您的手机号"
                v-model="userMsgdata.phone"
              />
            </div>
            <div class="submit-btn">
              <span>提交</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import scrollReveal from "scrollreveal";

  export default {
    data() {
      return {
        scrollReveal: scrollReveal(),
        activeDemandIndex: 1,
        demandTypeData: [
          {id: 1, name: "产品设计"},
          {id: 2, name: "软件开发"},
          {id: 3, name: "品牌设计"},
          {id: 4, name: "微信开发"},
          {id: 5, name: "方案咨询"},
          {id: 6, name: "网站定制"},
          {id: 7, name: "其他服务"},
        ],
        userMsgdata: {
          username: null,
          phone: null,
          demandId: null,
        },
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.scrollReveal.reveal(".contact-page-enter", {
          duration: 250,
          delay: 0,
          interval: 0,
          origin: "bottom",
          viewOffset: {
            bottom: 20,
          },
          reset: false,
          mobile: false,
          distance: "50px",
          opacity: 0.0,
          easing: "linear",
          scale: 0.99,
        });
        this.scrollReveal.reveal(".contact-page-left-enter", {
          duration: 200,
          delay: 0,
          interval: 0,
          origin: "left",
          viewOffset: {
            bottom: 200,
          },
          reset: false,
          mobile: false,
          distance: "100px",
          opacity: 0.0,
          easing: "linear",
          scale: 1,
        });
        this.scrollReveal.reveal(".contact-page-right-enter", {
          duration: 200,
          delay: 0,
          interval: 0,
          origin: "right",
          viewOffset: {
            bottom: 200,
          },
          reset: false,
          mobile: false,
          distance: "100px",
          opacity: 0.0,
          easing: "linear",
          scale: 1,
        });
      });
    },
    methods: {
      activeDemandIndexChange(index) {
        this.activeDemandIndex = index;
        this.userMsgdata.demandId = index;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .contact-page-container {
    width: 100%;

    .banner-container {
      background: url("../../../assets/image/main-background.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      height: 726px;
      display: flex;
      justify-content: center;
      align-items: center;

      .title {
        // padding-top: 243px;
        span {
          display: block;
          font-family: PingFangSC-Semibold;
          font-size: 40px;
          color: #ffffff;
          text-align: center;
        }

        span + span {
          font-family: PingFangSC-Semibold;
          font-size: 30px;
          color: #0057ff;
          text-align: center;
        }

        span + span + span {
          margin-top: 40px;
          font-family: PingFangSC-Medium;
          font-size: 20px;
          color: #ffffff;
        }
      }
    }

    .contact-content {
      /*margin: 100px 0;*/
      max-width: 1200px;
      margin: 100px auto 0;

      .contact-content-title {
        font-family: PingFangSC-Semibold;
        font-size: 40px;
        color: #000000;
        text-align: center;
      }

      .content-container {
        display: flex;
        justify-content: space-between;
        margin-top: 60px;
        /*padding: 0 120px;*/

        .left {
          flex: 1;

          .title {
            margin: 40px 0;
            font-family: PingFangSC-Semibold;
            font-size: 30px;
            color: #000000;
          }

          .content-card {
            margin-top: 30px;
            display: flex;

            .logo {
              margin-right: 14px;

              img {
                display: block;
                width: 30px;
                height: 30px;
              }
            }

            .content {
              span {
                display: block;
                font-family: PingFangSC-Medium;
                font-size: 16px;
                color: #000000;
              }

              span + span {
                margin-top: 6px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #5e5e5e;
              }
            }
          }

          .qr-code-container {
            margin: 21px 0 0 44px;
            width: 150px;
            height: 150px;
            background: url("../../../assets/image/icon-weChat.png") no-repeat;
            background-size: 150px 150px;
          }
        }

        .right {
          flex: 1;

          .demand-container {
            margin-top: 40px;

            .title {
              font-family: PingFangSC-Semibold;
              font-size: 30px;
              color: #000000;
            }

            .btns-container {
              width: 570px;
              display: flex;
              flex-wrap: wrap;
              margin-top: 10px;

              .btn {
                width: 104px;
                height: 40px;
                margin: 10px 10px 0 0;
                background: #efeef2;
                border-radius: 20px;
                font-family: PingFangSC-Regular;
                font-size: 16px;
                color: #000000;
                line-height: 26px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                user-select: none;
              }

              .active {
                background: #000000;
                color: #ffffff;
              }
            }
          }

          .contact-form-container {
            margin-top: 40px;

            .title {
              font-family: PingFangSC-Semibold;
              font-size: 30px;
              color: #000000;
            }

            .input-container {
              margin-top: 20px;
              display: flex;
              flex-direction: column;

              input {
                width: 300px;
                height: 40px;
                margin-bottom: 20px;
                box-sizing: border-box;
                padding: 7px 20px;
                border: 1px solid #000000;
                border-radius: 20px;
                font-family: PingFangSC-Regular;
                font-size: 16px;
                color: #848484;
                line-height: 26px;
              }
            }

            .submit-btn {
              width: 300px;
              height: 50px;
              margin-top: 20px;
              background: #0057ff;
              border-radius: 25px;
              font-family: PingFangSC-Medium;
              font-size: 18px;
              color: #ffffff;
              line-height: 26px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              user-select: none;

              &:active {
                opacity: 0.8;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/details/components/contactPage.vue